import {useState, type ComponentProps} from "react";
import {FA6Icon} from "@/primitives/FA6Icon";
import {Input} from "@/primitives/Input";
import {InputGroup} from "@/primitives/InputGroup";
import {Tooltip} from "@/primitives/Tooltip";
import {CopyButton} from "@/components/CopyButton";


export interface SecretInputGroupProps extends Omit<ComponentProps<typeof Input>, "type" | "value"> {
	value: string,
	canShow?: boolean,
	canCopy?: boolean,
}

export function SecretInputGroup({value, canShow = true, canCopy = true, ...inputProps}: SecretInputGroupProps) {
	// without the show/hide toggle the value would be irrecoverably masked, so it starts visible then
	const [hidden, setHidden] = useState(canShow);

	const hiddenLabel = hidden ? messages["tooltip.show"] : messages["tooltip.hide"];

	return (
		<Tooltip.Provider>
			<InputGroup.Root>
				{/* readOnly, NOT disabled: the value stays focusable/selectable and skips the browser's own disabled tinting */}
				<Input readOnly {...inputProps} type={hidden ? "password" : "text"} value={value}/>
				{canShow && (
					<Tooltip.Root>
						<Tooltip.Trigger
							render={
								<InputGroup.Button
									aria-label={hiddenLabel}
									aria-pressed={!hidden}
									onClick={() => setHidden(!hidden)}
								/>
							}
						>
							<FA6Icon icon={hidden ? "eye" : "eye-slash"} variant="regular" fixedWidth/>
						</Tooltip.Trigger>
						<Tooltip.Popup>{hiddenLabel}</Tooltip.Popup>
					</Tooltip.Root>
				)}
				{canCopy && <CopyButton text={value} render={<InputGroup.Button/>}/>}
			</InputGroup.Root>
		</Tooltip.Provider>
	);
}
